<script setup>
import { useNotificationsStore } from '@/store/notifications.store';

const notificationsStore = useNotificationsStore();

const copyText = () => {
	const text = props.text;
	navigator.clipboard.writeText(text)
		.then(() => {
			console.log('Text successfully copied to clipboard:', text);
			notificationsStore.showNotification('Text copied to clipboard!', 'success');
		})
		.catch(err => {
			console.error('Error copying text:', err);
		});
};

const props = defineProps({
	text: String
});
</script>

<template>
	<a href="#" @click.stop="copyText" class="copy">
		<span class="material-symbols-outlined">content_copy</span>
	</a>
</template>

<style scoped>
.copy:hover {
	color: #2563EB;
}
</style>